module.exports = __webpack_public_path__ + "static/media/tag-close.a3c133b0.svg";